import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { getApiBaseUrl } from '../config/api';
import { resolveAvatarUrl, handleAvatarError } from '../utils/profilePicUrl';
import { getAuthorDisplayName } from '../utils/displayName';
import './OnlineFeedSidebar.css';

export default function OnlineFeedSidebar({ user }) {
  const API_URL = getApiBaseUrl();
  const [onlineUsers, setOnlineUsers] = useState([]);

  useEffect(() => {
    if (!user?.id) return;

    const updateActivity = async () => {
      try {
        await fetch(`${API_URL}/update_activity.php`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ user_id: user.id }),
        });
      } catch (err) {
        console.error('Failed to update activity:', err);
      }
    };

    updateActivity();
    const interval = setInterval(updateActivity, 30000);
    return () => clearInterval(interval);
  }, [API_URL, user?.id]);

  useEffect(() => {
    const fetchOnlineUsers = async () => {
      try {
        const res = await fetch(`${API_URL}/get_online_users.php`);
        const data = await res.json();
        if (data.success && Array.isArray(data.users)) {
          setOnlineUsers(data.users);
        } else {
          setOnlineUsers([]);
        }
      } catch (err) {
        console.error('Error fetching online users:', err);
      }
    };

    fetchOnlineUsers();
    const interval = setInterval(fetchOnlineUsers, 30000);
    return () => clearInterval(interval);
  }, [API_URL]);

  return (
    <aside className="ofs-panel">
      <div className="ofs-header">
        <h2 className="ofs-title">
          <span className="ofs-dot" aria-hidden="true" />
          Online
        </h2>
        <span className="ofs-count">{onlineUsers.length}</span>
      </div>

      <div className="ofs-list">
        {onlineUsers.length === 0 ? (
          <p className="ofs-empty">No users online</p>
        ) : (
          onlineUsers.slice(0, 2).map((u) => (
            <Link key={u.id} to={`/profile/${u.id}`} className="ofs-person">
              <span className="ofs-avatar-wrap">
                <img
                  src={resolveAvatarUrl(u, API_URL)}
                  alt=""
                  className="ofs-avatar"
                  onError={handleAvatarError}
                />
                <span className="ofs-status" aria-hidden="true" />
              </span>
              <div className="ofs-info">
                <span className="ofs-name">{getAuthorDisplayName(u)}</span>
                {u.username && <span className="ofs-handle">@{u.username}</span>}
              </div>
            </Link>
          ))
        )}
      </div>
    </aside>
  );
}
